import Home from '../views/Home';
import Page404 from '../views/Page404';
import HomeTab from '../views/tabs/HomeTab';
import AboutTab from '../views/tabs/AboutTab';
import PortfolioTab from '../views/tabs/PortfolioTab';
import ContactTab from '../views/tabs/ContactTab';
import TextEditor from '../views/projects/text-editor';

const routes = [
    {
        path: '/',
        element: <Home />,
        errorElement: <Page404 />,
        children: [
            {
                index: true,
                element: <HomeTab />
            },
            {
                path: 'about',
                element: <AboutTab />
            },
            {
                path: 'portfolio',
                element: <PortfolioTab />
            },
            {
                path: 'contact',
                element: <ContactTab />
            }
        ]
    },
    {
        path: 'text-editor',
        element: <TextEditor/>
    },
    {
        path: '*',
        element: <Page404 />
    }
]
export default routes;